import { Link2 } from 'lucide-react';
import { SupplyBadge } from '@/features/supplier-catalog/components/SupplyBadge';

export interface JustInTimeStockProps {
  /** Whose stock it is, shown under the mark ("Thread Lab's shared stock"). */
  line?: string | null;
  /** The stock is another org's (a pool or a back-up): the link mark the shared figures carry. */
  linked?: boolean;
}

/**
 * BLU-1268: a stock figure that is Just in time, in the Inventory List and
 * Matrix. Not counted, never out of stock, so it shows the mark in words in
 * place of a number and a red, orange or green state; the line under it says
 * whose stock it is in visible words (DESIGN.md section 10).
 */
export function JustInTimeStock({ line, linked = false }: JustInTimeStockProps) {
  return (
    <span className="inline-flex flex-col items-start gap-0.5">
      <span className="inline-flex items-center gap-1">
        <SupplyBadge mode="just_in_time" />
        {linked && <Link2 className="h-3.5 w-3.5 shrink-0 text-threadheads-purple" aria-hidden="true" />}
      </span>
      {line && <span className="text-xs text-muted-foreground">{line}</span>}
    </span>
  );
}
